import React from 'react';

interface Props {
    children?: React.ReactNode;
    className?: string;
}

export default function FormError({ children, className = '' }: Props) {
    return <span className={`form-error-text ${className}`.trim()}>{children}</span>;
}
